import React, { useEffect, useState } from 'react';
import { getPlanCard } from '../services/api';
import ProgressBar from './common/ProgressBar';
import PlanTimeInfo from './common/PlanTimeInfo';
import './PlanPlaceDetail.css';

/**
 * PlanPlaceDetail Component
 * Toont details van een planplaats en de bijbehorende plankaartjes
 */
const PlanPlaceDetail = ({ conneoId, place, onBack }) => {
  const [planCards, setPlanCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlanCards = async () => {
      try {
        setLoading(true);
        
        // Haal plankaartjes op voor elk planItem
        if (place.planItems && place.planItems.length > 0) {
          const cardPromises = place.planItems.map(itemId => getPlanCard(itemId));
          const cardResponses = await Promise.all(cardPromises);
          setPlanCards(cardResponses);
        }
      } catch (err) {
        console.error('Error fetching plan cards:', err);
        setError('Er is een fout opgetreden bij het ophalen van de plankaartjes.');
      } finally {
        setLoading(false);
      }
    };
    
    // Stel paginatitel in
    document.title = `Conneo Planning - ${place.planPlaceId_S}`;
    
    fetchPlanCards();
  }, [place]);

  if (loading) {
    return <div className="loading">Laden...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error">{error}</div>
        <button onClick={onBack} className="btn-back">← Terug</button>
      </div>
    );
  }

  // Parse numerieke waarden
  let plannedTime = parseFloat(place.totalDone || 0);  //plannedTime
  let plannableTime = parseFloat(place.plannedTime || place.plannableTime || 8); //plannableTime
  console.log('plannedTime:', plannedTime);
  console.log('plannableTime:', plannableTime);
  if (isNaN(plannedTime) || plannedTime <= 0) {
    if (place.planItems && place.planItems.length > 0) 
      plannedTime = place.planItems.length * 0.01;
    else
      plannedTime = 0;
  }
  if (isNaN(plannableTime) || plannableTime <= 0) {
    if (place.planItems && place.planItems.length > 0) 
      plannableTime = place.planItems.length * 0.01 // 30 minuten per taak
    else
      plannableTime = 0;
  }

  return (
    <div className="plan-place-detail">
      <h2 className="place-header">{place.planPlaceId_S}</h2>
      <div className="place-date">{place.date}</div>
      
      <div className="place-info-panel">
        <ProgressBar plannedTime={plannedTime} plannableTime={plannableTime} />
        <PlanTimeInfo 
          plannedTime={plannedTime}
          plannableTime={plannableTime}
          planItems={place.planItems}
          availableTime={parseFloat(place.plannableTime || 0)}
        />
      </div>
      
      <div className="plan-cards">
        <h3 className="cards-heading">Plankaartjes</h3>
        
        {planCards.length === 0 ? (
          <div className="no-cards">Geen plankaartjes beschikbaar</div>
        ) : (
          planCards.map((card, index) => (
            <div 
              key={index} 
              className="plan-card"
              dangerouslySetInnerHTML={{ __html: card }}
            />
          ))
        )}
      </div>
      
      <button onClick={onBack} className="btn-back">← Terug</button>
    </div>
  );
};

export default PlanPlaceDetail;